import { RootState } from "@react-three/fiber";
import { AnimatePresence } from "framer-motion";
import React, { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { IS_CHAT_ENABLED } from "../config";
import ChatSystem from "../modules/chat";
import ChatButton from "../modules/chat/components/Buttons/ChatButton";
import { chatsSlice } from "../modules/chat/store/chatSlice";
import { ConnectorProvider } from "../game-engine/connector/context";
import { BattleProvider } from "../game-engine/context";
import { hubUrl } from "../game-engine/layouts/battle-layout";
import EventsProvider from "../game-engine/providers/events-prodvider";
import useAuth from "../hooks/useAuth";
import { setPlayable } from "../redux/music/action";
import RoutesConfig from "../routes/config";
import { IsBeta } from "../utils/Network";
import TourProvider from "./Tour/TourProvider";
import { arenaTutorialTourSteps } from "../tours/arena";
import { useMapModeRedirect } from "../hooks/useMapModeRedirect";
import ArenaTour from "./Tour/ArenaTour";


const { actions } = chatsSlice;

const Navigation = () => {
  const { userSettings } = useAuth();
  const dispatch = useDispatch();
  
  // Use the map mode redirect hook
  useMapModeRedirect();
  
  const enableBgMusic = () => {
    dispatch(setPlayable(true));
  };
  useEffect(() => {
    dispatch(actions.startCall());
  }, []);
  return (
    <>
      <AnimatePresence exitBeforeEnter>
        <RoutesConfig
          enableBgMusic={enableBgMusic}
          userSettings={userSettings}
          IsBeta={IsBeta}
        />
      </AnimatePresence>
    </>
  );
};

const Navigator = () => {
  const { userInfo, userToken }: any = useSelector<RootState>((state: any) => {
    return {
      userInfo: state.userInfo,
      userToken: state.userToken,
    };
  }, shallowEqual);

  return (
    <BrowserRouter>
      <TourProvider
        tours={[
          {
            id: "arenaTour",
            steps: arenaTutorialTourSteps,
            autoStart: false,
            showSkipButton: true,
            showProgress: true,
            showArrows: true,
            arrowSize: 40,
            forcedSteps: true,
            spotlightClicks: true,
            advanceOnTargetClick: true,
            advanceDelay: 200,
          },
        ]}
        renderHelpButton={false}
        enableContinuity={true}
      >
        <BattleProvider>
          <ConnectorProvider hubUrl={hubUrl!}>
            {IS_CHAT_ENABLED && !!userInfo && !!userToken && <ChatButton />}
            <EventsProvider>
              <Navigation />
              {IS_CHAT_ENABLED && <ChatSystem />}
              <ArenaTour />
            </EventsProvider>
          </ConnectorProvider>
        </BattleProvider>
      </TourProvider>
    </BrowserRouter>
  );
};

export default Navigator;
